import React from "react";
import { SelectPicker } from "rsuite";
import { ChatApp } from "../my-enum";

export interface ChatAppSelectProps {
  value: ChatApp | null | undefined;
  onChange: (value: ChatApp | null) => void;
  placeholder?: string;
  disabled?: boolean;
  block?: boolean;
}

/**
 * A dropdown component for selecting a Chat App.
 * Lists available chat applications for contacting passengers.
 */
export default function ChatAppSelect({
  value,
  onChange,
  placeholder = "請選擇聊天軟體",
  disabled = false,
  block = true
}: ChatAppSelectProps) {
  const chatAppOptions = [
    { label: "WhatsApp", value: ChatApp.WhatsApp },
    { label: "Facebook Messenger", value: ChatApp.FacebookMessenger },
    { label: "LINE", value: ChatApp.LINE },
    { label: "Viber", value: ChatApp.Viber },
    { label: "WeChat", value: ChatApp.WeChat },
    { label: "X", value: ChatApp.X },
    { label: "SnapChat", value: ChatApp.SnapChat },
    { label: "Telegram", value: ChatApp.Telegram },
    { label: "Signal", value: ChatApp.Signal },
    { label: "Discord", value: ChatApp.Discord },
    { label: "Kakao", value: ChatApp.Kakao },
  ];

  return (
    <SelectPicker
      data={chatAppOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      block={block}
      searchable
      cleanable
      style={{ width: block ? "100%" : undefined }}
    />
  );
}
